import { render, staticRenderFns } from "./terra-details.vue?vue&type=template&id=74128911"
import script from "./terra-details.vue?vue&type=script&lang=js"
export * from "./terra-details.vue?vue&type=script&lang=js"
import style0 from "./terra-details.vue?vue&type=style&index=0&id=74128911&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports